export enum PaymentStatus {
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
}

export const PaymentStatusNames = {
  [PaymentStatus.PAID]: 'Pago',
  [PaymentStatus.OVERDUE]: 'Vencido',
  [PaymentStatus.OPEN]: 'Aberto',
  [PaymentStatus.PROCESSING]: 'Processando',
};

export const PaymentStatusColors = {
  [PaymentStatus.PAID]: { bgColor: 'positive.primary', textColor: 'positive.overPrimary' },
  [PaymentStatus.OVERDUE]: { bgColor: 'negative.primary', textColor: 'negative.overPrimary' },
  [PaymentStatus.OPEN]: { bgColor: 'neutral.secondary', textColor: 'neutral.primaryAlt' },
  DEFAULT: { bgColor: 'neutral.secondary', textColor: 'neutral.primaryAlt' },
};

export enum ManagedStatus {
  EMPLOYER = 'EMPLOYER',
  CUSTOMER = 'CUSTOMER',
}

export const ManagedStatusNames = {
  [ManagedStatus.EMPLOYER]: 'Empresa',
  [ManagedStatus.CUSTOMER]: 'Cliente',
};

export enum PaymentOrigin {
  DATAPREV_PAYMENT = 'DATAPREV_PAYMENT',
  MANUAL_DATAPREV_PAYMENT = 'MANUAL_DATAPREV_PAYMENT',
  MEUTUDO_PAYMENT = 'MEUTUDO_PAYMENT',
  RECUPERA_PAYMENT = 'RECUPERA_PAYMENT',
  APP_SETLEMENT_PAYMENT = 'APP_SETLEMENT_PAYMENT',
  APP_EARLY_PAYMENT = 'APP_EARLY_PAYMENT',
  REFIN_SETTLEMENT_PAYMENT = 'REFIN_SETTLEMENT_PAYMENT',
  SYSTEM_ADJUSTMENT = 'SYSTEM_ADJUSTMENT',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
}

export const PaymentOriginNames = {
  [PaymentOrigin.DATAPREV_PAYMENT]: 'Dataprev',
  [PaymentOrigin.MANUAL_DATAPREV_PAYMENT]: 'Manual',
  [PaymentOrigin.MEUTUDO_PAYMENT]: 'Meutudo',
  [PaymentOrigin.RECUPERA_PAYMENT]: 'Recupera',
  [PaymentOrigin.APP_SETLEMENT_PAYMENT]: 'Quitado via app',
  [PaymentOrigin.APP_EARLY_PAYMENT]: 'Antecipação via app',
  [PaymentOrigin.REFIN_SETTLEMENT_PAYMENT]: 'Quitado por refin',
  [PaymentOrigin.SYSTEM_ADJUSTMENT]: 'Ajuste via sistema',
  [PaymentOrigin.MANUAL_ADJUSTMENT]: 'Ajuste manual',
};

export enum PaymentType {
  ORDINARY_WRITE_OFF = 'ORDINARY_WRITE_OFF',
  COMPLEMENTARY_WRITE_OFF = 'COMPLEMENTARY_WRITE_OFF',
  EXTRAORDINARY_WRITE_OFF = 'EXTRAORDINARY_WRITE_OFF',
  MANUAL_WRITE_OFF = 'MANUAL_WRITE_OFF',
  TOLERANCE_WRITE_OFF = 'TOLERANCE_WRITE_OFF',
}

export const PaymentTypeNames = {
  [PaymentType.ORDINARY_WRITE_OFF]: 'Normal',
  [PaymentType.COMPLEMENTARY_WRITE_OFF]: 'Complementar',
  [PaymentType.EXTRAORDINARY_WRITE_OFF]: 'Extraordinária',
  [PaymentType.MANUAL_WRITE_OFF]: 'Manual',
  [PaymentType.TOLERANCE_WRITE_OFF]: 'Tolerância',
};

export enum PaymentMode {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}

export const PaymentModeNames = {
  [PaymentMode.DEBIT]: 'Débito',
  [PaymentMode.CREDIT]: 'Crédito',
};

export enum ExternalPaymentStatus {
  PARTIAL = 'PARTIAL',
  TOTAL = 'TOTAL',
}

export const ExternalPaymentStatusNames = {
  [ExternalPaymentStatus.PARTIAL]: 'Pago parcialmente',
  [ExternalPaymentStatus.TOTAL]: 'Pago totalmente',
};

export const ExternalPaymentStatusColors = {
  [ExternalPaymentStatus.TOTAL]: { bgColor: 'positive.primary', textColor: 'positive.overPrimary' },
  [ExternalPaymentStatus.PARTIAL]: { bgColor: 'alert.primary', textColor: 'alert.overPrimary' },
  DEFAULT: { bgColor: 'neutral.secondary', textColor: 'neutral.primaryAlt' },
};
